<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Statybos leidimo numeris"
          tooltip="Hipoteka. Turtas. Būsimas NTR. Statybos leidimo numeris"
          :counter="20"
          :readonly="turtasReadonly || !sudarymas"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-autocomplete
          need
          :items="formData.ntr_rusys"
          itemvalue="text"
          itemtext="text"
          label="Turto rūšis"
          tooltip="Hipoteka. Turtas. Būsimas NTR. Turto rūšis"
          :readonly="turtasReadonly"
          v-model="formData.tur_busimas_ntr_rusis"
        />
      </v-col>
      <v-col cols="12" md="12">
        <el-adresas
          v-if="!adresasText"
          need
          label="Sklypo adresas"
          tooltip="Hipoteka. Turtas. Būsimas NTR. Sklypo adresas"
          :counter="200"
          :readonly="turtasReadonly"
          :lazy-load="true"
          v-model="formData.tur_busimas_ntr_adresas"
        >
          <template slot="append-outer">
            <el-button
              v-if="!turtasReadonly"
              class="inner-button"
              @click.native="changeAdresasInput()"
            >
              Įvesti adresą rankiniu būdu
            </el-button>
          </template>
        </el-adresas>

        <el-text-field
          v-if="adresasText"
          need
          label="Sklypo adresas"
          tooltip="Hipoteka. Turtas. Būsimas NTR. Sklypo adresas"
          :counter="200"
          :readonly="turtasReadonly"
          v-model="formData.tur_busimas_ntr_adresas"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasBusimasNtr',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  data() {
    return {
      adresasText: false,
    }
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
  methods: {
    changeAdresasInput() {
      this.adresasText = true
    },
  },
}
</script>

<style lang="scss" scoped>
.inner-button {
  top: -11px;
}
</style>
